import { Service } from '@angular/core';
import { ReviewFileUser } from '@common/reviews/models/review-file-user.model';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';

@CollectionStateSelectors({
  stateType: ReviewFileUsersState
})
@State<ReviewFileUsersState>({
  name: ReviewFileUsersState.source
})
@Service({ autoProvided: false })
export class ReviewFileUsersState extends CollectionStateBase {
  static override source = 'ReviewFileUsers';
  getSource(): string {
    return ReviewFileUsersState.source;
  }
}

@Service()
export class ReviewFileUsersDataService extends CollectionDataServiceBase<ReviewFileUser> {
  protected readonly stateType = ReviewFileUsersState;
}
